var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasYtd)?_c('div',{staticClass:"ytdval narrow_05"},[_vm._v("\n  "+_vm._s(_vm.getResult=='-' && _vm.getYear=='' ? '' : 'YTD')+_vm._s(_vm.getYear)),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.getResult=='-' && _vm.getYear=='' ? '' : _vm.getResult))])]):_c('div',{staticClass:"ytdval narrow_05"})
}
var staticRenderFns = []

export { render, staticRenderFns }